import cn from 'classnames';
import { useEffect, useState } from 'react';

import styles from './HeaderDivider.module.scss';

export const HeaderDivider = () => {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 0);
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className={cn(styles.container, { [styles.visible]: scrolled })} />
  );
};
